export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.19-1511.22",
  commitId: "8bf6b4f3320678bad5d8db9ad10c8c647acaa7a1",
  commitTime: "2026-10-19T15:11:22.000Z",
});
